import {
  publicUserPageSchema,
  type PublicUserPage,
  type PublicUserPhoto,
  type PublicUserSchedule,
  type PublicUserService,
  type PublicUserServiceOption,
  type PublicUserVacation,
} from "@openings/api-contract";
import { BaseHttpClient, baseOk, type ApiOk } from "./base";

const userPageDataSchema = baseOk(publicUserPageSchema);
export type UserScheduleDTO = PublicUserSchedule;
export type UserServiceDTO = PublicUserService;
export type UserServiceOptionDTO = PublicUserServiceOption;
export type UserVacationDTO = PublicUserVacation;
export type UserPhotoDTO = PublicUserPhoto;
export type UserPageDTO = PublicUserPage;
export type GetUserPageResult = ApiOk<UserPageDTO>;

export class UsersClient extends BaseHttpClient {
  getUserPage(
    identifier: string, // Username slug
    salonId?: string,
  ): Promise<GetUserPageResult> {
    const qs = new URLSearchParams();
    if (salonId) qs.set("salonId", salonId);
    return this.get(
      `/v1/users/by-username/${encodeURIComponent(
        identifier,
      )}/page?${qs.toString()}`,
      userPageDataSchema,
    );
  }

  /**
   * @deprecated Use `getUserPage` directly.
   */
  getUserPageByUsername(identifier: string, salonId?: string) {
    return this.getUserPage(identifier, salonId);
  }
}
